import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppStateService, StartupParams } from '@siza-staff-care/shared/app-state';
import { StartupCustomisationDto, SystemInfoController_Constants, Types } from '@siza-staff-care/shared/data';
import { JadeService } from '@siza-staff-care/shared/global-services';
import { Observable, catchError, of, tap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class StartupCustomisationService {
	constructor(
		private jade: JadeService,
		private appState: AppStateService,
		private title: Title,
	) {}

	loadConfigurationData(): Observable<StartupCustomisationDto> {
		const url = new URL(window.location.href);
		const passwordReset = url.searchParams.get('PasswordReset');
		const iCareSessionId = url.searchParams.get('ICareSessionId');

		const startupParams: StartupParams = {
			passwordResetKey: passwordReset ?? '',
			iCareSessionId: iCareSessionId ?? '',
		};

		this.appState.setStartupParams(startupParams);

		const param = {
			$type: Types.SystemInfoController,
		};

		return this.jade
			.controllerRequest<StartupCustomisationDto>(
				SystemInfoController_Constants.Operation_GetStartupCustomisation,
				param,
			)
			.pipe(
				tap((customisation) => {
					this.appState.setStartupCustomisation(customisation);

					if (customisation.appTitle) {
						this.title.setTitle(customisation.appTitle);
					}
				}),
				catchError(() => {
					this.appState.setStartupCustomisation(undefined);

					// Handle any error as having no customisation.
					// Likely to be a 404.
					return of({} as StartupCustomisationDto);
				}),
			);
	}
}
